<template>
  <div>
    <md-button
      class="md-icon-button md-dense refresh-btn"
      @click="toggleIsActive"
    >
      <md-tooltip md-direction="top"
      >Search
      </md-tooltip>
      <md-icon>search</md-icon>
    </md-button>

    <!--  menu part  -->
    <div class="menu" v-if="isActive">
      <div class="md-layout md-alignment-center-left">
        <div class="md-layout-item">
          <md-field>
            <label>Search</label>
            <md-input ref="searchInp" @keyup.esc="toggleIsActive" @input="updateValue" v-model="value"
                      @keyup.enter="$emit('doSearch')"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-button class="md-primary md-raised" @click="$emit('doSearch')"
          >search
          </md-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'SearchBox',
    props: ['clearOnClose', 'clearOnOpen'],
    data () {
      return {
        isActive: false,
        value: ''
      }
    },
    methods: {
      toggleIsActive: function () {
        this.isActive = !this.isActive
        if (this.isActive) {
          this.$emit('opened')
          this.$nextTick(() => this.$refs.searchInp.$el.focus())
          if (this.clearOnOpen)
            this.value = ''
        } else {
          this.$emit('closed')
          if (this.clearOnClose)
            this.value = ''
        }
      },
      updateValue: function () {
        this.$emit('input', this.value)
      }
    },
    mounted () {

    }
  }
</script>

<style scoped lang="scss">
  .menu {
    position: absolute;
    background-color: white;
    color: black;
    padding: 8px;
    z-index: 10;
    right: 70px;
    border-radius: 4px;
    box-shadow: 0 12px 20px -10px rgba(156, 39, 176, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(156, 39, 176, 0.2);
  }
</style>